/*
 * INIT: ensure Babel/Eslint/Flow is configured for ES Class Fields & Static Properties
 * JSX USAGE: <Iframe src='http://web.site' onLoad={myOnloadFunction}/>
 * */
import React, { PropTypes } from 'react'
import ReactDOM from 'react-dom'

export default class Iframe extends React.Component {
  componentDidMount () {
    this.iframe = ReactDOM.findDOMNode(this.refs.iframe);
    this.iframe.addEventListener('load', this.props.onLoad);
  }

  componentWillUnmount() {
    this.iframe.removeEventListener('load', this.props.onLoad);
  }

  render() {
    const iframeStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      border: 0,
      width: '100%',
      height: '100%',
    }

    return (
      <iframe
        ref="iframe"
        {...this.props}
        frameBorder={iframeStyle.border}
        width={iframeStyle.width}
        height={iframeStyle.height}
        style={iframeStyle}
      />
    )
  }
}

Iframe.proTypes = {
  src: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
};




// WEBPACK FOOTER //
// ./src/components/Iframe.js